/**
 * A native `<select>` styled like `Input`: the browser's own picker, which is
 * keyboard- and screen-reader-complete for free. Used where a list is short
 * and plain (a studio, a rundown, a piece type).
 */
import type { ComponentProps } from 'react';
import { cn } from '../../lib/utils.js';

export function NativeSelect({ className, ...props }: ComponentProps<'select'>) {
  return (
    <select
      data-slot="native-select"
      className={cn(
        'h-9 w-full min-w-0 rounded-md border border-input bg-transparent px-3 text-sm shadow-xs outline-none transition-colors focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive',
        className,
      )}
      {...props}
    />
  );
}
